import { physiotherapyMassages, relaxMassages, sensualMassages } from './massageSubcategories';

export const massageMainTypes = [
   'relaxed_massage',
   'sensual_massage',
   'physiotherapy',
   'osteopathy',
   'acupuncture',
];

export const massageMainTypeOptions = [
   { label: 'relaxed_massage', value: 'RELAXED_MASSAGE' },
   { label: 'sensual_massage', value: 'SENSUAL_MASSAGE' },
   { label: 'physiotherapy', value: 'PHYSIOTHERAPY' },
   { label: 'osteopathy', value: 'OSTEOPATHY' },
   { label: 'acupuncture', value: 'ACUPUNCTURE' },
   { label: 'chiropractic', value: 'CHIROPRACTIC' },
   { label: 'reflexotherapy', value: 'REFLEXOTHERAPY' },
   { label: 'hirudotherapy', value: 'HIRUDOTHERAPY' },
];

export const MASSAGE_TYPE_LABELS: { [key: string]: string } = {
   RELAXED_MASSAGE: 'relaxed_massage',
   SENSUAL_MASSAGE: 'sensual_massage',
   PHYSIOTHERAPY: 'physiotherapy',
   OSTEOPATHY: 'osteopathy',
   CHIROPRACTIC: 'chiropractic',
   ACUPUNCTURE: 'acupuncture',
   REFLEXOTHERAPY: 'reflexotherapy',
   HIRUDOTHERAPY: 'hirudotherapy',
   CLASSIC_MASSAGE: 'classical_massage',
   SPORT_MASSAGE: 'sports_massage',
   THAI_MASSAGE: 'thai_massage',
   HOT_STONES_MASSAGE: 'hot_stone_massage',
   CHOCOLATE_MASSAGE: 'chocolate_massage',
   HONEY_MASSAGE: 'honey_massage',
   CANDLE_MASSAGE: 'candle_massage',
   CHINESE_BUBBLE_MASSAGE: 'chinese_cupping_massage',
   ANTI_CELLULITE_MASSAGE: 'anti_cellulite_massage',
   HAWAIIAN_MASSAGE: 'hawaiian_massage',
   NURU_MASSAGE: 'nuru_massage',
   TANTRA_MASSAGE: 'tantra_massage',
   BODY_TO_BODY_MASSAGE: 'body_to_body_massage',
   ASMR_MASSAGE: 'ASMR',
   PHYSIOTHERAPEUTIC_CONSULTATIONS: 'physiotherapy_consultations',
   MEDICAL_MASSAGE: 'therapeutic_massage',
   REHABILITATION: 'rehabilitation',
   KINESIOTAPING: 'kinesiotaping',
   AROMATHERAPY: 'aromatherapy',
   KOBIDO_MASSAGE: 'kobido_massage',
   FACIAL_AND_CLEAVAGE_TREATMENTS: 'facial_and_cleavage_treatments',
   OTHER_MASSAGES_AND_TREATMENTS: 'other_massages_and_treatments',
   OTHER_SENSUAL_MASSAGES: 'other_sensual_massages',
   UROGYNECOLOGICAL_TREATMENTS: 'urogynecological_treatments',
   DENTAL_PHYSIOTHERAPY: 'dental_physiotherapy',
   OTHER_TREATMENTS: 'other_treatments',
};

export const massageTypeFilterGroupOptions = [
   { label: 'relaxed_massage', value: 'RELAXED_MASSAGE', subOptions: relaxMassages },
   { label: 'sensual_massage', value: 'SENSUAL_MASSAGE', subOptions: sensualMassages },
   { label: 'physiotherapy', value: 'PHYSIOTHERAPY', subOptions: physiotherapyMassages },
   { label: 'osteopathy', value: 'OSTEOPATHY' },
   { label: 'acupuncture', value: 'ACUPUNCTURE' },
   { label: 'chiropractic', value: 'CHIROPRACTIC' },
   { label: 'reflexotherapy', value: 'REFLEXOTHERAPY' },
   { label: 'hirudotherapy', value: 'HIRUDOTHERAPY' },
];
